import { render, staticRenderFns } from "./LabHome.component.html?vue&type=template&id=6448f5dd&scoped=true&"
import script from "./LabHome.component.ts?vue&type=script&lang=ts&"
export * from "./LabHome.component.ts?vue&type=script&lang=ts&"
import style0 from "./LabHome.component.scss?vue&type=style&index=0&id=6448f5dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448f5dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular})
